export enum MarketValueTransferRecordType {
  MarketValueOut = 'MarketValueOut',
  MarketValueIn = 'MarketValueIn',
  StandardExternal = 'StandardExternal',
  StandardCopy = 'StandardCopy',
}
